var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * DeltaDown component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconDeltaDown extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M4.57144 7.82764C4.34032 7.82764 4.13196 7.96686 4.04351 8.18039C3.95507 8.39391 4.00396 8.63969 4.16738 8.80312L11.1907 15.8264C11.294 15.9344 11.4178 16.0207 11.555 16.0801C11.6955 16.1409 11.8469 16.1722 12 16.1722C12.1531 16.1722 12.3045 16.1409 12.445 16.0801C12.5822 16.0207 12.7061 15.9344 12.8093 15.8264L19.8327 8.80312C19.9961 8.63969 20.0449 8.39391 19.9565 8.18039C19.868 7.96686 19.6597 7.82764 19.4286 7.82764H4.57144Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconDeltaDown.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconDeltaDown.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconDeltaDown.prototype, "size", void 0);
if (customElements.get('cat-icon-delta-down') === undefined) {
    customElements.define('cat-icon-delta-down', BlocksIconDeltaDown);
}
